import { clientBase } from "../common";

export const get_progress_course = (_mounted_course_id) => {
  return clientBase(`v2/getProgressUserCalc?mounted_course_id=${_mounted_course_id}`, "GET");
};

